// extracted by mini-css-extract-plugin
export default {"ricosDisabled":"M_Hr0T","checkbox":"rphMfR"};